import React, { useCallback } from 'react';

import { SelectionPanelBase } from './SelectionPanelBase';
import { SelectionPanelItem } from './SelectionPanelItem';
import { thunkCreateTask } from '../../../features/actions';
import { closeSelectionPanel } from '../../../features/ui/uiSlice';
import { useAppDispatch } from '../../../hooks';
import { TaskType } from '../../../types';
import { Icon as TasksIcon } from '../../customIcons/tasks';

export const ConditionalFlowSelectionPanel = () => {
  const dispatch = useAppDispatch();

  const handleClickItem = useCallback(
    (taskType: TaskType) => {
      dispatch(thunkCreateTask({ taskType }));
      dispatch(closeSelectionPanel());
    },
    [dispatch]
  );

  return (
    <SelectionPanelBase title="Conditional Flow">
      <SelectionPanelItem
        itemId="condition"
        icon={<TasksIcon iconType="condition" />}
        label="If/Else"
        handleClickItem={handleClickItem}
      />
    </SelectionPanelBase>
  );
};
